/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */

import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import packageReducer from './reducers/packageReducer';
import productReducer from './reducers/productReducer';
import cfgReducer from './reducers/cfgReducer';
import cartReducer from './reducers/cartReducer';
import checkoutReducer from './reducers/checkoutReducer';
import cartHelperReducer from './reducers/cartHelperReducer';
import filterReducer from './reducers/filterReducer';
import pageSettingsReducer from './reducers/pageSettingsReducer';
import storeDesignReducer from './reducers/storeDesignReducer';
import inspirationReducer from './reducers/inspirationReducer';

import {loadingBarReducer} from 'react-redux-loading-bar';
import {EMPTY_CART} from './actions/cartActions';

/*
 * routeReducer
 *
 * The reducer merges route location changes into our immutable state.
 * The change is necessitated by moving to react-router-redux@4
 *
 */

/**
 * Creates the main reducer with the asynchronously loaded ones
 */
export default function createReducer(asyncReducers) {
    return combineReducers({
        routing: routerReducer,
        loadingBar: loadingBarReducer,
        packages: packageReducer,
        products: productReducer,
        cfg: cfgReducer,
        cfgFilter: filterReducer,
        cart: cartReducer,
        cartHelper: cartHelperReducer,
        pageSettings: pageSettingsReducer,
        storeDesign: storeDesignReducer,
        checkout: checkoutReducer,
        inspiration: inspirationReducer
    });
}
